import React from 'react';
import ReactDOM from 'react-dom';
import ExpLoginWrapper from './components/ExpLogin/ExpLoginWrapper';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<ExpLoginWrapper />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js